module.exports = "<table class=\"table price-table\">\n    <tbody>\n        <tr>\n            <td class=\"title\">Per Acre:</td>\n            <td class=\"value\">${{ $ctrl.costPerAcre | number: 2 }}</td>\n        </tr>\n        <tr>\n            <td class=\"title\">Per Ton:</td>\n            <td class=\"value\">${{ $ctrl.costPerTon | number: 2 }}</td>\n        </tr>\n        <tr>\n            <td class=\"title\">Total:</td>\n            <td class=\"value\">${{ $ctrl.totalCost | number: 2 }}</td>\n        </tr>\n    </tbody>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/price.section.html
// module id = 612
// module chunks = 0